import { render, staticRenderFns } from "./LessonExercises.vue?vue&type=template&id=890545dc&scoped=true"
import script from "./LessonExercises.vue?vue&type=script&lang=js"
export * from "./LessonExercises.vue?vue&type=script&lang=js"
import style0 from "./LessonExercises.vue?vue&type=style&index=0&id=890545dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890545dc",
  null
  
)

export default component.exports